import styled from 'styled-components';

import mediaQueries from '@/theme/mediaQueries';

export const Container = styled.div`
    width: 100%;
    padding: 8px 16px;

    ${mediaQueries.laptop} {
        padding: 48px 0 48px 96px;
        max-width: 600px;
    }
`;

export const MealsContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;

    ${mediaQueries.laptop} {
        max-width: 600px;
    }
`;
